import { axiosPrivate } from "../config/axios";
import { IBookSeatDTO, IRemoveSeatDTO } from "../models/seat";
import { errorApi, successApi } from "./handle.response.api";

export const getSeatApi = async (busId: string, tripId: string) => {
  try {
    const res = await axiosPrivate.get(`/seats/${busId}?tripId=${tripId}`);
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Lấy chi tiết thất bại", error?.response?.data?.message);
  }
};
export const addSeatApi = async (payload: IBookSeatDTO) => {
  try {
    const res = await axiosPrivate.post(`/seats/booking`, payload);
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Lấy chi tiết thất bại", error?.response?.data?.message);
  }
};

export const removeSeatApi = async (payload: IRemoveSeatDTO) => {
  try {
    const res = await axiosPrivate.put(`/seats/booking/delete`, payload);
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Lấy chi tiết thất bại", error?.response?.data?.message);
  }
};
